import React from 'react';
import { IonBackButton, IonButtons, IonContent, IonHeader, IonPage, IonToolbar, withIonLifeCycle } from '@ionic/react';

//	L O C A L I Z A T I O N

import { locale___App } from '../../../App.locale';
import { locale___SbInfoAllergensPage } from './sb-info-allergens.locale';

//	S T Y L E

import './sb-info-allergens.style.scss';

//	S T A T E   -   P R O P S

import { state___SbInfoAllergensPage, state___SbInfoAllergensPage___default } from './sb-info-allergens.state';

//	T Y P E S

import { type___api___response } from '../../../types/type.api';

//	S E R V I C E S

import { service_LocalizationService } from '../../../services/service-localization';
import { service_RestApiService } from '../../../services/service-api';

//	C O M P O N E N T S

import ComCopyrightComponent from '../../../components/com-copyright/com-copyright';
import ComSpinnerInlineComponent from '../../../components/com-spinner-inline/com-spinner-inline';

//	C L A S S

class SbInfoAllergensPage extends React.Component<{}, state___SbInfoAllergensPage> {

//#region 																							D E C L A R A T I O N S
	
	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();
	private readonly _API: service_RestApiService = new service_RestApiService();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: {},
	) {
		super(props);
		this.state = state___SbInfoAllergensPage___default;
	}

//#endregion

//#region 																							R E A D   P R O P S

	read_props___digitalmenu_allergens = async () : Promise<void> => {
		const ___temp___dish_allergens: type___api___response = await this._API.public___read_allergens();
		this.setState({
			allergens_collection: ___temp___dish_allergens.data,
			allergens_collection___is_loading: false,
		});
	}

//#endregion

//#region 																							L I F E C Y C L E

	async ionViewDidEnter() : Promise<void> {
		await this.read_props___digitalmenu_allergens();
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return (
			<IonPage>

				<IonHeader className="ion-no-border" collapse="fade">
					<IonToolbar>
						<IonButtons slot="start">
							<IonBackButton defaultHref="/settings" text={ this._LOCALE.translate(locale___App.button___back) } />
						</IonButtons>
					</IonToolbar>
				</IonHeader>

				<IonContent>
					<div className="sb-info-allergens---container">

						<h2>{ this._LOCALE.translate(locale___SbInfoAllergensPage.title) }</h2>

						<br />

						{(this.state.allergens_collection___is_loading === true) ?( <>
							
							<br />
							<br />
							<br />
							<ComSpinnerInlineComponent/>

						</>) : (<>

							{this.state.allergens_collection.map((___a: any, ___a___idx: number) : React.ReactNode => (<>
								<div key={ ___a___idx } className="sb-info-allergens---card">
									<section>
										<img src={ '/assets/digitalmenu/allergens/' + ___a['dish_allergen_icon'] + '.svg' } />
										<h6>{ ___a['dish_allergen_name'] }</h6>
									</section>
									<p>{ ___a['dish_allergen_description'] }</p>
								</div>
								<br />
								<br />
							</>))}

						</>)}
					</div>

					<br />
					<br />
					<br />

					<ComCopyrightComponent />

				</IonContent>

			</IonPage>
		);
	}

//#endregion

}

//	E X P O R T

export default withIonLifeCycle(SbInfoAllergensPage);